import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { ContentProvider } from "./context/ContentContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import KaabaTransition from "./components/KaabaTransition";
import IntroSplash from "./components/IntroSplash";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Packages from "./pages/Packages";
import PackageDetail from "./pages/PackageDetail";
import CustomPackage from "./pages/CustomPackage";
import HalalTours from "./pages/HalalTours";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import HajjPreRegistration from "./pages/HajjPreRegistration";
import HajjRequirements from "./pages/HajjRequirements";
import Gallery from "./pages/Gallery";
import { Toaster } from "./components/ui/sonner";
import { AdminAuthProvider } from "./admin/AdminAuth";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminCollection from "./admin/AdminCollection";
import AdminSettings from "./admin/AdminSettings";
import AdminInquiries from "./admin/AdminInquiries";
import AdminAccount from "./admin/AdminAccount";

const AdminApp = () => (
  <AdminAuthProvider>
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="inquiries" element={<AdminInquiries />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="account" element={<AdminAccount />} />
        <Route path="c/:col" element={<AdminCollection />} />
      </Route>
    </Routes>
    <Toaster position="top-center" richColors />
  </AdminAuthProvider>
);

const AppRoutes = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return <AdminApp />;
  return (
    <>
      <IntroSplash />
      <KaabaTransition />
      <Navbar />
      <main>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/hajj" element={<Packages type="hajj" />} />
          <Route path="/hajj/pre-registration" element={<HajjPreRegistration />} />
          <Route path="/hajj/requirements" element={<HajjRequirements />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/umrah" element={<Packages type="umrah" />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/package/:slug" element={<PackageDetail />} />
          <Route path="/customize" element={<CustomPackage />} />
          <Route path="/halal-tours" element={<HalalTours />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
